import {
	OrderCancellationReasonEnum,
	OrderStatus,
} from "Infrastructure/Api/Api";
import { z } from "zod";

export const getStatusFormSchema = () => {
	return z.object({
		status: z.nativeEnum(OrderStatus).nullish(),
		dateStarting: z.string().nullish(),
		dateDone: z.string().nullish(),
		cancellationReason: z
			.nativeEnum(OrderCancellationReasonEnum)
			.optional()
			.nullable(),
	});
};

export type StatusFormModel = z.infer<ReturnType<typeof getStatusFormSchema>>;
